import S3PhotoModel from './S3PhotoModel';
import CollegeReportModel from './CollegeReportModel';

const alphaToNumeric = {
  "1": "1", "2": "2", "3": "3", 
  "4": "4", "5": "5", "6": "6",
  "7": "7", "8": "8", "9": "9",
  "0": "0", "+": "0",

  "a": "2", "b": "2", "c": "2",
  "d": "3", "e": "3", "f": "3",
  "g": "4", "h": "4", "i": "4",
  "j": "5", "k": "5", "l": "5",
  "m": "6", "n": "6", "o": "6",
  "p": "7", "q": "7", "r": "7", "s": "7",
  "t": "8", "u": "8", "v": "8",
  "w": "9", "x": "9", "y": "9", "z": "9",

  "A": "2", "B": "2", "C": "2",
  "D": "3", "E": "3", "F": "3",
  "G": "4", "H": "4", "I": "4",
  "J": "5", "K": "5", "L": "5",
  "M": "6", "N": "6", "O": "6",
  "P": "7", "Q": "7", "R": "7", "S": "7",
  "T": "8", "U": "8", "V": "8",
  "W": "9", "X": "9", "Y": "9", "Z": "9",
}

export default class CollegeModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.name = data.name || '';

    this.logo = data.logo ? new S3PhotoModel(data.logo) : null;
    this.banner_image = data.banner_image ? new S3PhotoModel(data.banner_image) : null;

    this.counseling_center_hours = data.counseling_center_hours || null;
    this.counseling_center_location = data.counseling_center_location || '';
    this.counseling_center_phone = data.counseling_center_phone || '';
    this.main_counselor_name = data.main_counselor_name || '';
    this.main_counselor_phone = data.main_counselor_phone || '';
    this.campus_crisis_info = data.campus_crisis_info || '';
    this.messageForNewUserPrompt = data.messageForNewUserPrompt || '';

    this.bettermynd_crisis_phone = data.bettermynd_crisis_phone || '';

    // added for admin dashboard things - most of CollegeReportModel
    this.is_member = data.is_member || false;
    this.report = new CollegeReportModel(data);
  }

  get display_name() {
    return this.name;
  }

  get banner() {
    return this.banner_image || null;
  }

  get betterMyndCrisisPhoneHref() {
    const length = this.bettermynd_crisis_phone.length;
    if (!length) 
      return ''
      
    let digits = ''
    for(const letter of this.bettermynd_crisis_phone)
      if(alphaToNumeric[letter])
        digits += alphaToNumeric[letter];

    if(digits.length === 11)
      return `tel:+${digits}`;

    return `tel:${digits}`;
  }
  get betterMyndCrisisNumericPhone() {
    const length = this.bettermynd_crisis_phone.length;
    if (!length) 
      return ''
      
    let digits = ''
    for(const letter of this.bettermynd_crisis_phone)
      if(alphaToNumeric[letter])
        digits += alphaToNumeric[letter];
      else
        digits += letter;

    return digits;
  }

  get counselingCenterPhoneHref() {
    if (this.counseling_center_phone.length) {
      return `tel:${this.counseling_center_phone.replace(/\D/g, '')}`;
    }

    return '';
  }

  get mainCounselorPhoneHref() {
    if (this.main_counselor_phone.length) {
      return `tel:${this.main_counselor_phone.replace(/\D/g, '')}`;
    }

    return '';
  }
}
